






















import { defineComponent, inject } from '@vue/composition-api'

// Components
import PhoneModal from '@/component/form/Phone/Modal.vue'
import ScheduleDate from '@/component/form/Field/ScheduleDate.vue'
import ScheduleTime from '@/component/form/Field/ScheduleTime.vue'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'

export default defineComponent({
    components: {
        PhoneModal,
        ScheduleDate,
        ScheduleTime,
    },
    setup() {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }

        return {
            formStore,
        }
    },
})
